import React, { useState, useEffect } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import SchoolColorPicker from './SchoolColorPicker';
import GbSearchIcon from '../Icons/GbSearchIcon';
import axios from 'axios';
import { RedrawMap } from '../../utils/MapUtils';
import * as settings from '../../settings'

export default function SchoolListItem(props) {
    const school = props.school
    const mySettings = props.settings
    const sidebarSettings = props.sidebarSettings
    const map = mySettings.map
    const [data, setReqData] = useState()
    const [anchorEl, setAnchorEl] = React.useState(null);

    if (school.color === "") {
        school.color = '#333333'
    }

    // SCHOOL LOOKUP

    function schoolLookup(c) {
        axios
            .get(`${settings.API_SERVER}/api/school_detail/${school.id}/`)
            .then((res) => {
                sidebarSettings.setSchool(res.data)
                sidebarSettings.setDrawerOpen(true)
            })
            .catch(function (e) {
                console.log(e)
            })
    }

    // SWAPS

    function handleChange(id) {
        setReqData(id)
        console.log(id)
        axios
            .get(`${settings.API_SERVER}/api/swaps/pop_score/${props.settings.plan}/${id}/`)
            .then((res) => {
                console.log(res.data)
                mySettings.setSuggestedSwaps(res.data)
            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                }
            })
    }

    // COLOR

    function handleChangeComplete(c) {
        school.color = c.hex
        axios
            .put(`${settings.API_SERVER}/api/school_detail/${school.id}/`, { color: c.hex })
            .then((res) => {
                RedrawMap(map)
                setAnchorEl(a => !a)
            })
            .catch((e) => console.log(e))
    }

    function blackOrWhite(c) {
        const hex = c.replace('#', '');
        const c_r = parseInt(hex.substr(0, 2), 16);
        const c_g = parseInt(hex.substr(2, 2), 16);
        const c_b = parseInt(hex.substr(4, 2), 16);
        const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
        const bright = brightness > 90;

        if (bright) {
            return "black"
        } else {
            return "white"
        }
    }

    return (
        <TableRow sx={{ backgroundColor: school.color, "&:hover": { opacity: 0.8 } }}>
            <TableCell sx={{ borderBottom: "none" }} onClick={schoolLookup} >
                <Typography variant="body1" sx={{ padding: 0, fontWeight: "700", letterSpacing: "0.5px", color: blackOrWhite(school.color) }}>
                    {school.name}
                </Typography>
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none" }} >
                <GbSearchIcon
                    handleChange={handleChange} val={school.id} />
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none" }} >
                <SchoolColorPicker
                    handleChangeComplete={handleChangeComplete}
                    school={school} anchor={anchorEl} map={mySettings.map} />
            </TableCell>
        </TableRow>
    )
}
